import { t } from "@/i18n-js/instance";
import { CreateCourseButton } from "@circle-react/components/Courses/CoursesLandingPage/CreateCourseButton";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const LandingFooter = () => (
  <div className="border-primary rounded-lg border p-14">
    <div className="mx-auto flex w-full max-w-2xl flex-col items-center text-center">
      <Typography.TitleXl weight="font-bold" color="text-dark">
        {t("courses.landing_page_v3.footer.title")}
      </Typography.TitleXl>
      <div className="mt-2 text-center">
        <Typography.TitleSm color="text-dark">
          {t("courses.landing_page_v3.footer.description")}
        </Typography.TitleSm>
      </div>
      <CreateCourseButton variant="circle" large className="mt-8">
        {t("courses.landing_page_v3.cta")}
      </CreateCourseButton>
    </div>
  </div>
);
